import { useState, useEffect } from 'react';
import { Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import classNames from "classnames";

// Custom Component
import { TournamentCard } from "../Card";
import NoTournament from "./NoTournament";
import ErrorAlert from '../Alert/ErrorAlert';

// API Service
import { allClosingSoonTournamentService, allOrganizerClosingSoonTournamentService } from '../../service/dashboard.service';

// Redux-Functions
import { selectUser } from "../../redux/userSlice"

const ClosingSoonTournament = () => {
    const user = useSelector(selectUser);

    const [closingSoonTournamentList, setClosingSoonTournamentListt] = useState([])

    /**
        * @function fetchClosingSoonTournamentList
        * @params
        * @description fetch the list of closing soon tournament
    */
    const fetchClosingSoonTournamentList = async () => {
        try {
            const result = await allClosingSoonTournamentService();
            if (result?.data?.status) {
                setClosingSoonTournamentListt(result?.data?.data)
            } else {
                ErrorAlert(result?.response?.data?.message)
            }
        } catch (error) {
            ErrorAlert(error)
        }
    }

    /**
        * @function fetchOrganizerClosingSoonTournamentList
        * @params
        * @description fetch the list of closing soon tournament for organizer
    */
    const fetchOrganizerClosingSoonTournamentList = async () => {
        try {
            const result = await allOrganizerClosingSoonTournamentService();
            if (result?.data?.status) {
                setClosingSoonTournamentListt(result?.data?.data)
            } else {
                ErrorAlert(result?.response?.data?.message)
            }
        } catch (error) {
            ErrorAlert(error)
        }
    }

    useEffect(() => {
        if (user?.type === 'organizer') {
            fetchOrganizerClosingSoonTournamentList();
        } else {
            fetchClosingSoonTournamentList();
        }
        // eslint-disable-next-line
    }, [])

    return <Row className={classNames({
        'my-3': closingSoonTournamentList.length > 0,
        'my-5': closingSoonTournamentList.length === 0
    })}>
        {closingSoonTournamentList.length > 0 ? closingSoonTournamentList.map((item, index) => {
            return <TournamentCard item={item} key={index} closingSoon={true} />
        })
            :
            <NoTournament />
        }
    </Row>;
};

export default ClosingSoonTournament;